import httpService from "./httpService";

export default {
  getToken(vbAttachmentId, docId) {
    return httpService.get("vbAttachmentToken/getToken", {
      params: { vbAttachmentId: vbAttachmentId, docId: docId }
    });
  },

  getTokenImage(attachmentMetaId) {
    return httpService.get("vbAttachmentToken/getTokenImage", {
      params: { attachmentMetaId: attachmentMetaId }
    });
  },

  getTokenDocRelation(docRelationId) {
    return httpService.get("vbAttachmentToken/getTokenDocRelation", {
      params: { docRelationId: docRelationId }
    });
  },

  getTokenForReferenceOutgoingAttachment(vbAttachmentId) {
    return httpService.get(
      "vbAttachmentToken/getTokenForReferenceOutgoingAttachment",
      { params: { vbAttachmentId: vbAttachmentId } }
    );
  },

  // Lấy file ký tạm ở từng bước
  downloadFileSigned(attachmentId) {
    return httpService.get(
      `vbAttachmentToken/downloadOriginalOutgoingDocAsBase64`,
      { params: { attatchmentId: attachmentId } }
    );
  },

  downloadOriginalOutgoingDocForVTAsBase64(docId) {
    return httpService.get(
      "vbAttachmentToken/downloadOriginalOutgoingDocForVTAsBase64",
      { params: { docId: docId } }
    );
  },

  getTokenForDocRelateWithTask(taskId, docId) {
    return httpService.get("vbAttachmentToken/getTokenForDocRelateWithTask", {
      params: { taskId: taskId, docId: docId }
    });
  },

  getTokenForReferenceOutgoingDoc(docId) {
    return httpService.get(
      "vbAttachmentToken/getTokenForReferenceOutgoingDoc",
      { params: { docId: docId } }
    );
  },

  getTokenForOutgoingDoc(docId) {
    return httpService.get("vbAttachmentToken/getTokenForOutgoingDoc", {
      params: { docId: docId }
    });
  },

  getTokenForOutgoingDocWithToken(docId, objectType) {
    let params = { objectType: objectType, docId: docId };
    return httpService.get(
      "vbAttachmentToken/getTokenForOutgoingDocWithToken",
      { params: params }
    );
  },

  getTokenForIncomingDoc(docId) {
    return httpService.get("vbAttachmentToken/getTokenForIncomingDoc", {
      params: { docId: docId }
    });
  },

  getTokenAttachmentComment(vbAttachmentId) {
    return httpService.get("vbAttachmentToken/getTokenAttachmentComment", {
      params: { vbAttachmentId: vbAttachmentId }
    });
  },

  getTokenForShareLibrary(vbAttachmentId) {
    return httpService.get("vbAttachmentToken/getTokenForShareLibrary", {
      params: { vbAttachmentId: vbAttachmentId }
    });
  },

  getTokenForHcCaseCalendarAttachment(hcCaseCalendarId, vbAttachmentId) {
    return httpService.get(
      "vbAttachmentToken/getTokenForHcCaseCalendarAttachment",
      {
        params: {
          hcCaseCalendarId: hcCaseCalendarId,
          vbAttachmentId: vbAttachmentId
        }
      }
    );
  },

  getTokenForHcCommandsDocRelation(
    objectId,
    objectType,
    referenceObjectType,
    referenceObjectId
  ) {
    return httpService.get(
      "vbAttachmentToken/getTokenForHcCommandsDocRelation",
      {
        params: {
          objectId: objectId,
          objectType: objectType,
          referenceObjectType: referenceObjectType,
          referenceObjectId: referenceObjectId
        }
      }
    );
  },

  getTokenForHcCaseFlightFile(
    hcCaseFlightId,
    hcCaseFlightFileId,
    vbAttachmentId
  ) {
    return httpService.get("vbAttachmentToken/getTokenForHcCaseFlightFile", {
      params: {
        hcCaseFlightId: hcCaseFlightId,
        hcCaseFlightFileId: hcCaseFlightFileId,
        vbAttachmentId: vbAttachmentId
      }
    });
  },

  getTokenForTaskAttachment(tkTaskId, attachmentId) {
    return httpService.get("vbAttachmentToken/getTokenForTaskAttachment", {
      params: {
        tkTaskId: tkTaskId,
        attachmentId: attachmentId
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/vbAttachmentTokenService.js